import { render, staticRenderFns } from "./OrganInfectionDetails.vue?vue&type=template&id=cc310dc4"
import script from "./OrganInfectionDetails.vue?vue&type=script&lang=js"
export * from "./OrganInfectionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports